import cardiovascularRiskCheck from './learnMore/cardiovascularRiskCheck.js';
import skinCheck from './learnMore/skinCheck.js';
import diabetesScreening from './learnMore/diabetesScreening.js';
import vitaminB12Tracking from './learnMore/vitaminB12Tracking.js';
import stiScreeningMale from './learnMore/stiScreeningMale.js';
import stiScreeningFemale from './learnMore/stiScreeningFemale.js';
import gynaecologyCheckUp from './learnMore/gynaecologyCheckUp.js';
import prostateCancerScreening from './learnMore/prostateCancerScreening.js';
import colonCancerScreening from './learnMore/colonCancerScreening.js';
import ironCheck from './learnMore/ironCheck.js';
import socialEggFreezing from './learnMore/socialEggFreezing.js';
import weightLossMedication from './learnMore/weightLossMedication.js';
import elevatedBloodSugarAndDiabetes from './learnMore/elevatedBloodSugarAndDiabetes.js';
import lipoproteinA from './learnMore/lipoproteinA.js';
import bloodLipids from './learnMore/blood-lipids.js';
import fattyLiver from './learnMore/fattyLiver.js';
import hypothyroidism from './learnMore/hypothyroidism.js';
import antiMullerianHormone from './learnMore/antiMullerianHormone.js';
import stefanZechmann from './learnMore/stefanZechmann.js';
import lealy from './learnMore/lealy.js';

const postsContent = [
  cardiovascularRiskCheck,
  skinCheck,
  diabetesScreening,
  vitaminB12Tracking,
  stiScreeningMale,
  stiScreeningFemale,
  gynaecologyCheckUp,
  prostateCancerScreening,
  colonCancerScreening,
  ironCheck,
  socialEggFreezing,
  weightLossMedication,
  elevatedBloodSugarAndDiabetes,
  lipoproteinA,
  bloodLipids,
  fattyLiver,
  hypothyroidism,
  antiMullerianHormone,
  stefanZechmann,
  lealy
];

export default postsContent;
